
import React                from 'react';
import { observer, inject } from 'mobx-react';

import { Menu              } from './commun/Menu';
import { BandeauSmartphone } from './commun/BandeauSmartphone';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                        AccueilSmartphone                      ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export const AccueilSmartphone = inject(['store'])(observer(class AccueilSmartphone extends React.Component {

  /* ---------------------- */
  /* Affichage du composant */
  /* ---------------------- */

  render() {

    /* ------------------------------ */
    /* Définition des CSS d'affichage */
    /* ------------------------------ */

    const styleBlocTexte = {
      width        : (window.innerWidth - 20) + "px",
      display      : "block",
      marginTop    : "30px",
      marginLeft   : "auto",
      marginRight  : "auto",
      marginBottom : "10px",
      textAlign    : 'center'
    };

    /* ----------------------------------------- */
    /* Définition de l'onglet du menu à afficher */
    /* ----------------------------------------- */

    this.props.store.definirSelectionOnglet ("accueil");

    /* ------------------------------- */
    /* Définition du titre de l'onglet */
    /* ------------------------------- */

    document.title = "Accueil - La geste d'Aros";

    /* -------------------------------- */
    /* Formatage des données à afficher */
    /* -------------------------------- */

    /* ------------------- */
    /* Renvoi du composant */
    /* ------------------- */

    return (

        <div id='divAccueilSmartphone' style={{textAlign:'center'}}> 

              <BandeauSmartphone />

              <Menu menu = {this.props.store.menu} />

              <div style={styleBlocTexte}>  

                    <p className="Accueil">
                      Salutations, honorable visiteur !
                    </p>

                  <p className="Recit">
                      Que vous soyez un lecteur avide d’aventures épiques, passionnantes et de bon goût, ou un simple passant curieux, je vous souhaite la bienvenue sur ce site consacré à «&nbsp;La geste d’Aros&nbsp;».
                  </p>
                  <p className="Recit">
                      Mais tout d’abord, autorisons-nous une petite définition d'un des mots du titre de la saga : 
                  </p>
                      <p className="DecaleSmartphone">
                          <b>GESTE :</b><br />
                          Ensemble de poèmes en vers du Moyen Âge, narrant les hauts faits de héros ou de personnages illustres.<br />
                          Par extension&nbsp;: Histoire glorifiante (d'un peuple, d'un groupe social, d'un individu).
                      </p>
                      <p className="Recit">
                        Il m’a semblé pertinent de le rappeler tant il est vrai que ce terme n’est plus guère utilisé de nos jours, du moins dans le langage courant.
                      </p>
                      <br />
                      <p className="Recit">
                        <b>La geste d’Aros</b> est une suite de romans fantastiques dont l’action se déroule dans un monde médiéval baigné par la magie et peuplé de créatures surnaturelles. Les habitués des jeux de rôles comme «&nbsp;Donjons et Dragons&nbsp;» ne seront pas dépaysés, tout comme les amateurs du «&nbsp;Seigneur des anneaux&nbsp;» et du «&nbsp;Trône de fer&nbsp;» (toutes proportions gardées bien sûr…). Il en sera de même pour ceux qui parmi vous jouent à «&nbsp;World of Warcraft&nbsp;» et à l’incroyable quantité de jeux vidéos existants de nos jours sur le thème de l'Heroic fantasy.
                      </p>
                      <p className="Recit">
                        Si vous n’entrez dans aucune de ces catégories, pas de panique&nbsp;: le plus important reste la qualité de l’histoire contée, et accessoirement le style de la narration. Ce dernier point étant plus une histoire de goût qu’autre chose, chacun l’appréciera (ou non) selon sa sensibilité. Evidemment, si vous êtes allergique aux chevaliers, sorcières et autres dragons («&nbsp;Que des choses qui n’existent pas&nbsp;», dirait quelqu’un de ma connaissance), j’ai bien peur que cette histoire ne soit pas pour vous. Mais si en revanche, sans être un passionné du genre, vous gardez l’esprit ouvert, vous devriez trouver de quoi alimenter tant votre curiosité que votre soif d’aventure.
                      </p>
                      <p className="Recit">
                          <b>Aros</b> est le nom du royaume d’où sont issus la plupart des personnages (mais pas tous) et dans lequel se dérouleront la majeure partie leurs aventures. Les personnages sont nombreux, plus ou moins complexes et mystérieux, pas forcément tous présents au début de l’intrigue. Je vais même me permettre un plagiat et reprendre une partie de l’évaluation postée par un de mes lecteurs sur Amazon : 
                      </p>
                      <p className="Recit">
                          «&nbsp;Un univers avec de multiples personnages qui s’intègrent dans une trame narrative riche et créative. On suit ces personnages qui au fur et à mesure du roman se croisent, s’associent, se combattent, s’aiment ou se trahissent. Chaque personnage mérite un roman à lui seul.&nbsp;»
                      </p>
                      <p className="Recit">
                        Je n’aurais pas dit mieux.
                      </p>

                      <br />

             </div>

        </div>
      )
    } 
  } // Fin de la classe AccueilSmartphone
))



// WEBPACK FOOTER //
// ./src/components/AccueilSmartphone.js